window._ = require('lodash');
window.$ = require('jquery');
window.jQuery = window.$;
window.axios = require('axios');
window.select2 = require('select2');

const cookieObj = new URLSearchParams(
    document.cookie.replaceAll('; ','&')
);

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = cookieObj.get('XSRF-TOKEN');
